import { Box, Grid } from "@mui/material";
import dayjs from "dayjs";
import CustomDatePicker from "../../../../../components/CustomDatePicker";
import CustomSelect from "../../../../../components/CustomSelect";
import Input from "../../../../../components/Input";
import MaskInput from "../../../../../components/MaskInput";
import AddressCommon from "../../../../../components/app/provider/patient/add-new-patient/preferences/AddressCommon";
import { GENDER } from "../../../../../constants/master";
import {
  MARITAL_STATUS,
  RELATIONSHIP_WITH_PATIENT,
} from "../../../../../constants/provider/add-new-patient";
import { STATE_STRING_LIST } from "../../../../../constants";

interface IntakeBasicDetailsProps {
  values: any;
  setFieldValue: any;
  handleChange: any;
  handleBlur: any;
  touched: any;
  errors: any;
  viewOnly?: boolean;
}

const IntakeBasicDetails = ({
  values,
  setFieldValue,
  handleChange,
  handleBlur,
  touched,
  errors,
  viewOnly,
}: IntakeBasicDetailsProps) => {
  return (
    <Box mt={1} id={"Patient Details"}>
      {/* <Divider textAlign="left" sx={{ mb: 1 }}>
        <Text>PATIENT DETAILS</Text> */}
      {/* <Chip label="Chip" size="small" /> */}
      {/* </Divider> */}
      {/* <CustomTitle mb={1}>PATIENT DETAILS</CustomTitle> */}

      {/* <OutlineCard> */}
      <Grid item container xs={12} spacing={2.6}>
        <DefaultBreakpointGrid>
          <Input
            label="First Name"
            textFieldProps={{
              name: "firstName",
              value: values.firstName,
              disabled: viewOnly,
              onChange: handleChange,
              onBlur: handleBlur,
              placeholder: "Enter Name",
            }}
            required
            error={touched?.firstName && (errors as any)?.firstName}
          />
        </DefaultBreakpointGrid>
        <DefaultBreakpointGrid>
          <Input
            label="Last Name"
            textFieldProps={{
              name: "lastName",
              value: values.lastName,
              disabled: viewOnly,
              onChange: handleChange,
              onBlur: handleBlur,
              placeholder: "Enter Name",
            }}
            required
            error={touched?.lastName && (errors as any)?.lastName}
          />
        </DefaultBreakpointGrid>
        <DefaultBreakpointGrid>
          <CustomDatePicker
            disabled={viewOnly}
            label="Date Of Birth"
            name="birthDate"
            maxDate={dayjs(new Date())}
            placeholder="Choose Date"
            handleBlur={handleBlur}
            value={values.birthDate ? dayjs(values.birthDate) : null}
            onChange={(value) => setFieldValue("birthDate", value)}
          />
        </DefaultBreakpointGrid>
        <Grid item xs={12} sm={6} lg={3}>
          <CustomSelect
            readOnly={viewOnly}
            value={values.sex}
            onChange={(value) => setFieldValue("sex", value)}
            label="Sex"
            clearable
            placeholder="Select Sex"
            options={GENDER}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <Input
            label="Social Security"
            textFieldProps={{
              name: "socialSecurity",
              value: values.socialSecurity,
              disabled: viewOnly,
              onChange: handleChange,
              onBlur: handleBlur,
              placeholder: "Enter Social Security",
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <MaskInput
            disabled={viewOnly}
            mask={"(999) 999-9999"}
            label="Mobile Number"
            name="mobileNumber"
            onBlur={handleBlur}
            placeholder="Enter Number"
            value={values.mobileNumber}
            onChange={(e) => setFieldValue("mobileNumber", e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6} lg={3}>
          <Input
            label="Email"
            textFieldProps={{
              name: "email",
              disabled: viewOnly,
              value: values.email,
              onChange: handleChange,
              onBlur: handleBlur,
              placeholder: "Enter Email",
            }}
          />
        </Grid>

        <AddressCommon
          formik={{ values, setFieldValue, handleBlur, handleChange } as any}
          formikKey={`address`}
          disabled={viewOnly}
          stateList={STATE_STRING_LIST}
        />

        <DefaultBreakpointGrid>
          <CustomSelect
            readOnly={viewOnly}
            options={MARITAL_STATUS}
            value={values.maritalStatus}
            onChange={(value) => {
              setFieldValue("maritalStatus", value);
            }}
            label="Marital Status"
          />
        </DefaultBreakpointGrid>
        <DefaultBreakpointGrid>
          <Input
            label="Spouse Name"
            textFieldProps={{
              name: "spouseName",
              disabled: viewOnly,
              value: values.spouseName,
              onChange: handleChange,
              onBlur: handleBlur,
              placeholder: "Enter Spouse",
            }}
          />
        </DefaultBreakpointGrid>
        <DefaultBreakpointGrid>
          <Input
            label="Spouse Phone Number"
            textFieldProps={{
              name: "spousePhoneNumber",
              disabled: viewOnly,
              value: values.spousePhoneNumber,
              onChange: handleChange,
              onBlur: handleBlur,
              placeholder: "Enter Spouse Phone Number",
            }}
          />
        </DefaultBreakpointGrid>
        <DefaultBreakpointGrid>
          <Input
            label="Emergency Contact"
            textFieldProps={{
              name: "emergencyContact",
              disabled: viewOnly,
              value: values.emergencyContact,
              onChange: handleChange,
              onBlur: handleBlur,
              placeholder: "Enter Emergency Contact",
            }}
          />
        </DefaultBreakpointGrid>

        <DefaultBreakpointGrid>
          <CustomSelect
            readOnly={viewOnly}
            label="Relationship With Patient"
            value={values.relationshipWithPatient}
            onChange={(value) => {
              setFieldValue("relationshipWithPatient", value);
            }}
            placeholder="Select"
            options={RELATIONSHIP_WITH_PATIENT}
          />
        </DefaultBreakpointGrid>
        <DefaultBreakpointGrid>
          <MaskInput
            disabled={viewOnly}
            mask={"(999) 999-9999"}
            label="Phone Number"
            name="phoneNumber"
            onBlur={handleBlur}
            placeholder="Enter Number"
            value={values.phoneNumber}
            onChange={(e) => setFieldValue("phoneNumber", e.target.value)}
            // error={touched?.mobileNumber && errors?.mobileNumber}
          />
        </DefaultBreakpointGrid>
      </Grid>
      {/* </OutlineCard> */}
    </Box>
  );
};

export default IntakeBasicDetails;

export const DefaultBreakpointGrid = ({ children }: { children: any }) => (
  <Grid item xs={12} sm={6} lg={4}>
    {children}
  </Grid>
);
